/* eslint-disable @typescript-eslint/no-require-imports */
import Constants from 'expo-constants';
import { isWeb } from 'shared/constants/platform';
import { Environment } from 'shared/providers/environment.constants';

type EnvironmentVars = {
  [key: string]: string;
};

function getEnvironmentVar(variable: string) {
  if (isWeb && typeof window !== 'undefined') {
    const url = window.location?.href ?? '';
    const match = url.match(/https:\/\/(.*?)-bank\.varomoney\.com/);
    const environment = match ? match[1] : 'prod';

    let vars: EnvironmentVars;

    if (window.location?.hostname === 'prod-cruise-web.varomoney.com') {
      vars = require('vars.prod.js') as EnvironmentVars;

      return vars?.[variable];
    }

    if (url.includes('localhost')) {
      switch (Constants.expoConfig?.extra?.EXPO_ENV) {
        case Environment.PROD:
          vars = require('vars.prod.js') as EnvironmentVars;
          break;
        default:
          vars = require('vars.uat.js') as EnvironmentVars;
      }
    } else {
      switch (environment as Environment) {
        case Environment.PROD:
          vars = require('vars.prod.js') as EnvironmentVars;
          break;
        default:
          vars = require('vars.uat.js') as EnvironmentVars;
      }
    }

    return vars?.[variable];
  }

  return Constants.expoConfig?.extra?.[variable] as string;
}

export default getEnvironmentVar;
